import React, { useEffect, useState } from "react";

import { api, AssetLocation, IListCarParks } from "../../logic/api";
import { PagedDataView } from "../../components/lists/PagedDataView/PagedDataView";

import propTypes from "prop-types";
import CarParkListItem from "./components/CarParkListItem";
import { IconButton } from "@mui/material";
import { FiPlus } from "react-icons/fi";
import CarParkEditorDialog from "./components/CarParkEditor";
import { useTranslation } from "react-i18next";

const CarParkManager: React.FunctionComponent<{
  customerId: number;
}> = (props) => {

  const [carParkListFetchParams, setCarParkListFetchParams] = useState<IListCarParks>({
    customerId: props.customerId
  });



  const [showCarParkDialog, setShowCarParkDialog] = useState(false);
  const [selectedCarPark, setSelectedCarPark] = useState<AssetLocation | null>(null);

  useEffect(() => {
    setCarParkListFetchParams({ ...carParkListFetchParams, customerId: props.customerId });
  }, [props.customerId]);


  const CarParkDialog = () => {

    return (
      <CarParkEditorDialog
        customerId={props.customerId}
        carPark={selectedCarPark}
        show={showCarParkDialog}
        onClose={(didSave) => {
          setSelectedCarPark(null);
          setShowCarParkDialog(false);
          if (didSave == true) {
            setCarParkListFetchParams({ ...carParkListFetchParams });
          }
        }}
      ></CarParkEditorDialog>
    );
  };

  const { t } = useTranslation();

  return (
    <div>
      <CarParkDialog />
      <div style={{ textAlign: "right", marginBottom: 20 }}>
        <IconButton
          onClick={() => {
            setShowCarParkDialog(true);
            setSelectedCarPark(null);
          }}
        >
          <FiPlus />
        </IconButton>
      </div>
      <PagedDataView<IListCarParks, AssetLocation>
        apiHook={api.hooks.admin.listCarParks}
        parameters={carParkListFetchParams}
        renderItem={(item) => {
          return (
            <CarParkListItem carPark={item} onEdit={(cp) => {
              setShowCarParkDialog(true);
              setSelectedCarPark(cp);
            }}></CarParkListItem>
          );
        }}
      >
        {t("admin.noCarparks")}
      </PagedDataView>
    </div>
  );
};

CarParkManager.propTypes = {
  customerId: propTypes.number.isRequired,
};

export default CarParkManager;

